import React from 'react';
import { FiCheck } from 'react-icons/fi';

import './completed-indicator.scss';

const CompletedIndicator = () => (
  <div className="completed-container">
    <div className="completed-container__icon">
      <FiCheck />
    </div>
  </div>
);

export default CompletedIndicator;
